// extracted by mini-css-extract-plugin
export default {"overview":"HNIQDSRqJbsgsw6psqIT","attributeList":"ufpqFb1RRR7P4tukKSG4"};